import { JSX } from 'react'

import CanadianLogoHorizontalWhite from '@/components/_svgs/CanadianLogoHorizontalWhite'
import Clock from '@/components/_svgs/Clock'
import CaretRight from '@/components/_svgs/CaretRight'
import FooterSymbol from '@/components/_svgs/FooterSymbol'
import DTF from '@/components/_svgs/DTF'
import CaretDown from '@/components/_svgs/CaretDown'
import HeaderLogo from '@/components/_svgs/HeaderLogo'
import Close from '@/components/_svgs/Close'
import Hamburger from '@/components/_svgs/Hamburger'
import Play from '@/components/_svgs/Play'
import SpeakerOff from '@/components/_svgs/SpeakerOff'
import SpeakerOn from '@/components/_svgs/SpeakerOn'
import Check from '@/components/_svgs/Check'
import Spinner from '@/components/_svgs/Spinner/Spinner'
import NewBadgeFilled from '@/components/_svgs/NewBadgeFilled'
import NewItemBadge from '@/components/_svgs/NewItemBadge'
import NewLocationBadge from '@/components/_svgs/NewLocationBadge'
import NewLocationBadgeFilled from '@/components/_svgs/NewLocationBadgeFilled'
import Asterisk from '@/components/_svgs/Asterisk'

const Icons: Record<IconName, ({ className }: SvgProps) => JSX.Element> = {
  asterisk: Asterisk,
  canadianLogoHorizontalWhite: CanadianLogoHorizontalWhite,
  caretDown: CaretDown,
  caretRight: CaretRight,
  check: Check,
  clock: Clock,
  close: Close,
  dtf: DTF,
  footerSymbol: FooterSymbol,
  hamburger: Hamburger,
  headerLogo: HeaderLogo,
  newBadgeFilled: NewBadgeFilled,
  newItemBadge: NewItemBadge,
  newLocationBadge: NewLocationBadge,
  newLocationBadgeFilled: NewLocationBadgeFilled,
  play: Play,
  speakerOff: SpeakerOff,
  speakerOn: SpeakerOn,
  spinner: Spinner,
}

export default function Icon({ name, className }: IconProps) {
  const Icon = Icons[name as keyof typeof Icons]
  if (!Icon) return null

  return <Icon className={className} />
}
